import React, { useEffect } from 'react';
import { FileCheck } from 'lucide-react';

const TermsConditions: React.FC = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-gray-50">
      <section className="bg-gradient-to-br from-primary-dark via-primary to-accent py-16">
        <div className="container mx-auto px-4 text-center text-white">
          <FileCheck className="w-16 h-16 mx-auto mb-4" />
          <h1 className="text-5xl font-extrabold mb-4 drop-shadow-2xl">Términos y Condiciones</h1>
          <p className="text-xl font-light drop-shadow-lg">Última actualización: 19 de octubre de 2025</p>
        </div>
      </section>

      <section className="py-12">
        <div className="container mx-auto px-4 max-w-4xl">
          <div className="bg-white p-8 md:p-12 rounded-2xl shadow-lg">
            <div className="prose prose-lg max-w-none
              [&>h2]:text-2xl [&>h2]:font-bold [&>h2]:text-primary [&>h2]:mt-8 [&>h2]:mb-4 [&>h2]:pb-2 [&>h2]:border-b-2 [&>h2]:border-accent/30
              [&>p]:text-gray-700 [&>p]:leading-relaxed [&>p]:mb-4
              [&>ul]:list-disc [&>ul]:list-inside [&>ul]:space-y-2 [&>ul]:mb-4 [&>ul]:text-gray-700
              [&>ul>li]:ml-4">
              <p>Estos Términos y condiciones regulan el uso de trabajofuera.com y las relaciones derivadas de los servicios ofrecidos por Trabajo Fuera Ltd. Al acceder o utilizar el sitio, usted acepta estos Términos, la Política de privacidad y el Aviso legal.</p>

              <h2>1. Descripción del servicio</h2>
              <p>Trabajo Fuera Ltd ofrece información y servicios relacionados con trabajar en el extranjero, incluyendo orientación y, en su caso, intermediación en procesos de selección. Las características y condiciones específicas de cada servicio se detallarán en el acuerdo correspondiente.</p>

              <h2>2. Registro y comunicaciones</h2>
              <p>Al comunicarse con nosotros, acepta recibir comunicaciones electrónicas necesarias para gestionar su solicitud o el servicio. Puede solicitar dejar de recibir comunicaciones comerciales en cualquier momento.</p>

              <h2>3. Requisitos de edad</h2>
              <p>El sitio y los servicios están dirigidos exclusivamente a personas de 18 años o más.</p>

              <h2>4. Contenidos informativos</h2>
              <p>Los artículos y contenidos del blog se ofrecen únicamente con fines informativos y no constituyen asesoramiento legal ni una oferta de empleo.</p>

              <h2>5. Propiedad intelectual</h2>
              <p>Los contenidos del sitio pertenecen a Trabajo Fuera Ltd o a sus licenciantes. No se concede licencia de uso más allá de lo permitido por la ley o por autorización expresa.</p>

              <h2>6. Contenido y enlaces de terceros</h2>
              <p>Podemos incluir enlaces a sitios de terceros. No controlamos su contenido ni políticas y no asumimos responsabilidad por ellos.</p>

              <h2>7. Conducta de la persona usuaria</h2>
              <p>La persona usuaria se compromete a no utilizar el sitio para fines ilícitos, a no introducir malware ni intentar acceder a áreas restringidas o sistemas sin autorización.</p>

              <h2>8. Condiciones económicas y pagos</h2>
              <p>Salvo pacto específico, los pagos por servicios se realizarán mediante transferencia bancaria a la cuenta indicada por Trabajo Fuera Ltd. Los importes, plazos y conceptos se detallarán en el acuerdo de servicios correspondiente.</p>

              <h2>9. Cancelaciones y reembolsos</h2>
              <p>Las condiciones sobre cancelaciones, cambios o reembolsos se regirán por lo establecido en el acuerdo específico de cada servicio y por la normativa imperativa aplicable.</p>

              <h2>10. Limitación de responsabilidad</h2>
              <p>En la medida permitida por la ley aplicable, Trabajo Fuera Ltd no será responsable de daños indirectos, incidentales, especiales o consecuenciales derivados del uso o imposibilidad de uso del sitio o de los servicios. Nada de lo aquí previsto limita la responsabilidad que no pueda excluirse legalmente.</p>

              <h2>11. Fuerza mayor</h2>
              <p>No seremos responsables por retrasos o incumplimientos debidos a causas fuera de nuestro control razonable.</p>

              <h2>12. Modificaciones</h2>
              <p>Podemos actualizar estos Términos cuando sea necesario. La versión vigente se publicará en el sitio indicando la fecha de última actualización.</p>

              <h2>13. Protección de datos</h2>
              <p>El tratamiento de datos personales se rige por nuestra Política de privacidad.</p>

              <h2>14. Ley aplicable y jurisdicción</h2>
              <p>Salvo que la normativa imperativa disponga otra cosa, estos Términos se rigen por la legislación del Reino Unido y cualquier disputa se someterá a los tribunales de Inglaterra y Gales.</p>

              <h2>15. Contacto</h2>
              <p>Para consultas sobre estos Términos, escriba a info@trabajofuera.com (Hamish Jefford).</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TermsConditions;
